export const ADD_ITEM = 'ADD_ITEM'
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY'
export const REMOVE_ITEM = 'REMOVE_ITEM'